import { userInformationStyles } from "@insite/content-library/Widgets/AccountSettings/AccountSettingsUserInformation";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

userInformationStyles.userInformationGridItem = {
	width: 12,
	css: css`
		label{
			font-weight: 600;
		}
		input{
			&:disabled{
				color: ${getColor("text.main")} !important;
				opacity: 0.5!important;
			}
		}
	`
}

userInformationStyles.changePasswordLink = {
	css: css`
		margin-left: 10px;
		font-weight: 400;
	`,
}